<syn-dropdown #dropdown placement="bottom-end" [distance]="8">

  <!-- Trigger: avatar circle -->
  <button slot="trigger" type="button"
    class="w-10 h-10 rounded-full overflow-hidden flex items-center justify-center select-none font-bold text-sm cursor-pointer border-0 outline-none"
    style="background-color: var(--syn-color-neutral-500); color: var(--syn-color-neutral-0)"
    [attr.aria-label]="'header.userMenu' | translate">
    <img *ngIf="avatarUrl()" [src]="avatarUrl()" alt="avatar" class="w-full h-full object-cover" />
    <span *ngIf="!avatarUrl()">{{ getUserName() | uppercase }}</span>
  </button>

  <!-- Panel: user card — uses Synergy panel tokens so it adapts to both themes -->
  <div class="flex flex-col rounded shadow-lg overflow-hidden"
    style="min-width: 280px; background-color: var(--syn-panel-background-color); border: 1px solid var(--syn-panel-border-color)">
    <!-- User info row -->
    <div class="flex items-center gap-4 px-5 py-5" style="border-bottom: 1px solid var(--syn-panel-border-color)">
      <!-- Large avatar -->
      <div class="w-14 h-14 rounded-full overflow-hidden flex items-center justify-center select-none font-bold text-2xl shrink-0"
        style="background-color: var(--syn-color-neutral-500); color: var(--syn-color-neutral-0)">
        <img *ngIf="avatarUrl()" [src]="avatarUrl()" alt="avatar" class="w-full h-full object-cover" />
        <span *ngIf="!avatarUrl()">{{ getUserName() | uppercase }}</span>
      </div>

      <!-- Name + email -->
      <div class="flex flex-col min-w-0">
        <span class="font-bold text-xl leading-tight truncate" style="color: var(--syn-typography-color-text)">
          {{ authService.session()?.name }}
        </span>
        <span class="text-sm truncate" style="color: var(--syn-color-neutral-500)">
          {{ authService.session()?.email }}
        </span>
      </div>
    </div>

    <!-- Actions -->
    <div class="flex flex-col py-1">

      <!-- My Account -->
      <button class="menu-item flex items-center gap-3 text-sm cursor-pointer border-0 bg-transparent text-left"
        style="padding: 0.625rem 1rem; margin: 0 0.5rem; border-radius: 4px; color: var(--syn-typography-color-text)"
        (click)="goToProfile()">
        <syn-icon name="account_circle" style="font-size: 1.1rem; flex-shrink: 0"></syn-icon>
        {{ 'profile.title' | translate }}
      </button>

      <!-- Change Password -->
      <button class="menu-item flex items-center gap-3 text-sm cursor-pointer border-0 bg-transparent text-left"
        style="padding: 0.625rem 1rem; margin: 0 0.5rem; border-radius: 4px; color: var(--syn-typography-color-text); border-top: 1px solid var(--syn-panel-border-color)"
        (click)="changePassword()">
        <syn-icon name="lock" style="font-size: 1.1rem; flex-shrink: 0"></syn-icon>
        {{ 'action.changePassword' | translate }}
      </button>

      <!-- About -->
      <button class="menu-item flex items-center gap-3 text-sm cursor-pointer border-0 bg-transparent text-left"
        style="padding: 0.625rem 1rem; margin: 0 0.5rem; border-radius: 4px; color: var(--syn-typography-color-text); border-top: 1px solid var(--syn-panel-border-color)"
        (click)="openAbout()">
        <syn-icon name="info" style="font-size: 1.1rem; flex-shrink: 0"></syn-icon>
        {{ 'header.about' | translate }}
      </button>

      <!-- Logout -->
      <button class="menu-item flex items-center gap-3 text-sm cursor-pointer border-0 bg-transparent text-left"
        style="padding: 0.625rem 1rem; margin: 0 0.5rem; border-radius: 4px; color: var(--syn-typography-color-text); border-top: 1px solid var(--syn-panel-border-color)"
        (click)="logout()">
        <syn-icon name="logout" style="font-size: 1.1rem; flex-shrink: 0"></syn-icon>
        {{ 'header.logout' | translate }}
      </button>

    </div>

    <!-- Version Info -->
    <div class="px-5 py-2 text-center text-xs"
      style="border-top: 1px solid var(--syn-panel-border-color); color: var(--syn-color-neutral-500)">
      {{ appVersion }}
    </div>
  </div>

</syn-dropdown>

<!-- About Dialog -->
<syn-dialog [label]="'header.about' | translate" [open]="isAboutOpen" (syn-request-close)="isAboutOpen = false"
  style="--width: 420px">
  <!-- Content: name + version top, SICK logo bottom-left -->
  <div class="flex flex-col" style="min-height: 160px; position: relative; padding-bottom: 3rem">

    <!-- App name + version -->
    <h1 class="m-0 text-xl font-bold leading-tight" style="color: var(--syn-typography-color-text)">
      {{ appName }}
    </h1>
    <p class="mt-2 text-sm" style="color: var(--syn-color-neutral-500)">{{ appVersion }}</p>

    <!-- SICK logo pinned bottom-left -->
    <img src="assets/images/logo-blue.svg" alt="SICK Logo"
      style="position: absolute; bottom: .5rem; left: 0; height: 28px; width: auto; opacity: 0.85" />
  </div>

</syn-dialog>